(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["salt-rush-game"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sra]').forEach(function (root) {
    var W = 360, H = 520;
    // The catcher is a tall glass. On touch screens it sits higher and taller
    // so the player's thumb rests below it instead of covering it.
    var COARSE = window.matchMedia('(pointer: coarse)').matches;
    var GLASS_W = 56, GLASS_H = COARSE ? 100 : 82;
    var GLASS_Y = COARSE ? H - 175 : H - 14 - GLASS_H;
    var TIERS = [
      { mg: 800, label: '10% OFF', key: '10' },
      { mg: 1600, label: '15% OFF', key: '15' },
      { mg: 2400, label: '20% OFF', key: '20' }
    ];

    var DURATION = parseInt(root.dataset.duration, 10) || 60;
    var stage = root.querySelector('[data-sra-stage]');
    var clockEl = root.querySelector('[data-sra-clock]');
    var canvas = root.querySelector('[data-sra-canvas]');
    var ctx = canvas.getContext('2d');
    var mgEl = root.querySelector('[data-sra-mg]');
    var hiEl = root.querySelector('[data-sra-hi]');
    var hearts = root.querySelectorAll('.sra__heart');
    var tierEls = {};
    root.querySelectorAll('[data-sra-tier]').forEach(function (el) { tierEls[el.dataset.sraTier] = el; });
    var screens = {};
    root.querySelectorAll('[data-sra-screen]').forEach(function (el) { screens[el.dataset.sraScreen] = el; });
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var COL = {
      na: '#4fc3f7', naDk: '#2b8fc2', k: '#ffd23f', kDk: '#c79c1a',
      mg: '#b388ff', mgDk: '#7e5cc4', gold: '#f2a900', goldDk: '#b57500',
      white: '#fbfcff', bad: '#f4364c', glass: '#eaf2ff', liquid: '#009cde',
      ink: '#0b1230', star: 'rgba(234,242,255,0.22)'
    };

    // Page takeover: lock scroll while the arcade is mounted.
    document.documentElement.style.overflow = 'hidden';

    var muted = false;
    try { muted = localStorage.getItem('sra-muted') === '1'; } catch (e) {}
    var muteBtn = root.querySelector('[data-sra-mute]');
    muteBtn.setAttribute('aria-pressed', String(!muted));
    var actx = null;
    function beep(freq, dur, type, gain) {
      if (muted) return;
      try {
        actx = actx || new (window.AudioContext || window.webkitAudioContext)();
        var o = actx.createOscillator(), g = actx.createGain();
        o.type = type || 'square';
        o.frequency.value = freq;
        g.gain.setValueAtTime(gain || 0.035, actx.currentTime);
        g.gain.exponentialRampToValueAtTime(0.0001, actx.currentTime + dur);
        o.connect(g).connect(actx.destination);
        o.start();
        o.stop(actx.currentTime + dur);
      } catch (e) {}
    }
    muteBtn.addEventListener('click', function () {
      muted = !muted;
      muteBtn.setAttribute('aria-pressed', String(!muted));
      try { localStorage.setItem('sra-muted', muted ? '1' : '0'); } catch (e) {}
    });

    // --- pixel sprites -------------------------------------------------
    function sprite(rows, pal) {
      var c = document.createElement('canvas');
      c.width = rows[0].length; c.height = rows.length;
      var x = c.getContext('2d');
      rows.forEach(function (row, ry) {
        for (var rx = 0; rx < row.length; rx++) {
          var col = pal[row[rx]];
          if (col) { x.fillStyle = col; x.fillRect(rx, ry, 1, 1); }
        }
      });
      return c;
    }
    var DROP = [
      '...X...',
      '...X...',
      '..XXX..',
      '.XXXXX.',
      '.WXXXX.',
      'XWXXXXX',
      'XXXXXXX',
      '.XXXXD.',
      '..XDD..'
    ];
    var SPR = {
      na: sprite(DROP, { X: COL.na, W: '#bfe9ff', D: COL.naDk }),
      mg: sprite(DROP, { X: COL.mg, W: '#e2d4ff', D: COL.mgDk }),
      heart: sprite([
        '.XX.XX.',
        'XWXXXXX',
        'XXXXXXX',
        '.XXXXX.',
        '..XXX..',
        '...X...'
      ], { X: COL.k, W: '#fff1bd' }),
      sugar: sprite([
        'OOOOOOOO',
        'OFFFFFFO',
        'OFSFFFFO',
        'OFFFFSFO',
        'OFFSFFFO',
        'OFFFFFFO',
        'OFFFFSFO',
        'OOOOOOOO'
      ], { O: '#d4dcee', F: COL.white, S: '#b9c4dd' }),
      gold: sprite([
        '..XXXX..',
        '.XXWXXX.',
        'XXWXXXXX',
        'XXXXXXDX',
        '.XXXXDD.',
        '..XXXX..',
        '...XX...'
      ], { X: COL.gold, W: '#ffe9a8', D: COL.goldDk })
    };
    var ITEM_SIZE = { na: 27, mg: 27, heart: 24, sugar: 26, gold: 30 };

    // --- state ---------------------------------------------------------
    var running = false, items, particles, floaters, score, lives, elapsed, glassX, slowUntil, timeScale, spawnAt, goldAt, jackpot, tiersHit, rafId, lastTs, stars;
    var hi = 0;
    try { hi = parseInt(localStorage.getItem('sra-hi') || '0', 10) || 0; } catch (e) {}
    hiEl.textContent = hi;

    // Best-reward banking: the highest reward earned on this device sticks
    // across runs, and the email gate only offers codes that BEAT the last one
    // sent, so every email is an upgrade.
    var RANK_LABEL = { 1: '10% OFF', 2: '15% OFF', 3: '20% OFF', 4: 'BUY 1 GET 1 FREE' };
    var RANK_KEY = { 1: '10', 2: '15', 3: '20', 4: 'gold' };
    function readRank(k) {
      try { return parseInt(localStorage.getItem(k) || '0', 10) || 0; } catch (e) { return 0; }
    }
    function writeRank(k, v) {
      try { localStorage.setItem(k, String(v)); } catch (e) {}
    }
    var bestRank = readRank('sra-best-rank');
    var sentRank = readRank('sra-sent-rank');

    function fitCanvas() {
      var r = stage.getBoundingClientRect();
      var scale = Math.min(r.width / W, r.height / H);
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.style.width = Math.floor(W * scale) + 'px';
      canvas.style.height = Math.floor(H * scale) + 'px';
      canvas.width = Math.floor(W * scale * dpr);
      canvas.height = Math.floor(H * scale * dpr);
      ctx.setTransform(canvas.width / W, 0, 0, canvas.height / H, 0, 0);
      ctx.imageSmoothingEnabled = false;
    }
    window.addEventListener('resize', fitCanvas);
    fitCanvas();

    stars = [];
    for (var si = 0; si < 40; si++) stars.push({ x: Math.random() * W, y: Math.random() * H, tw: Math.random() * 6.28 });

    function show(name) {
      Object.keys(screens).forEach(function (k) { screens[k].classList.toggle('is-open', k === name); });
    }

    var lastTick = -1;
    function updateClock() {
      var left = Math.max(0, Math.ceil(DURATION - elapsed));
      clockEl.textContent = Math.floor(left / 60) + ':' + (left % 60 < 10 ? '0' : '') + (left % 60);
      clockEl.classList.toggle('is-low', running && left <= 10);
      if (running && left <= 5 && left !== lastTick) {
        lastTick = left;
        if (left > 0) beep(980, 0.05, 'square', 0.03);
      }
    }

    function updateHud() {
      mgEl.textContent = score;
      hearts.forEach(function (h, i) { h.classList.toggle('is-empty', i >= lives); });
      TIERS.forEach(function (t) { tierEls[t.key].classList.toggle('is-hit', score >= t.mg); });
      tierEls.gold.classList.toggle('is-hit', jackpot);
    }

    function reset() {
      items = []; particles = []; floaters = [];
      score = 0; lives = 3; elapsed = 0; glassX = W / 2;
      slowUntil = 0; timeScale = 1; spawnAt = 0.6; goldAt = 0; jackpot = false;
      tiersHit = {}; lastTick = -1;
      updateHud();
      updateClock();
    }

    function addFloater(text, x, y, color, big) {
      floaters.push({ text: text, x: Math.min(W - 30, Math.max(30, x)), y: y, life: big ? 1.6 : 0.9, color: color, big: big });
    }

    function burst(x, y, color, n) {
      if (reducedMotion) return;
      for (var i = 0; i < n; i++) {
        particles.push({ x: x, y: y, vx: (Math.random() - 0.5) * 200, vy: -Math.random() * 190 - 30, life: 0.5 + Math.random() * 0.35, color: color });
      }
    }

    // Difficulty scales with BOTH time and score, so strong players hit a real
    // wall: 800mg is easy, 2400mg takes work, past ~3200mg it gets brutal and
    // the run ends on its own instead of dragging.
    function fallSpeed() {
      return 120 + elapsed * 3 + score * 0.055 + Math.random() * 40;
    }
    function spawn() {
      var roll = Math.random();
      var sugarShare = Math.min(0.42, 0.13 + elapsed * 0.0035 + score * 0.00005);
      var heartShare = lives < 3 ? 0.04 : 0;
      var type;
      if (roll < sugarShare) type = 'sugar';
      else if (roll < sugarShare + heartShare) type = 'heart';
      else if (roll < sugarShare + heartShare + 0.055) type = 'mg';
      else type = 'na';
      items.push({
        type: type,
        x: 24 + Math.random() * (W - 48),
        y: -30,
        vy: fallSpeed(),
        drift: (Math.random() - 0.5) * Math.min(60, 24 + elapsed * 0.8),
        wob: Math.random() * 6.28
      });
    }

    function maybeSpawnGold() {
      if (jackpot || score < 1600) return;
      var hasGold = items.some(function (it) { return it.type === 'gold'; });
      if (hasGold) return;
      if (elapsed - goldAt < 11) return;
      goldAt = elapsed;
      items.push({
        type: 'gold',
        x: 30 + Math.random() * (W - 60),
        y: -30,
        vy: fallSpeed() * 1.6,
        drift: 0,
        zig: 120 + Math.random() * 60,
        wob: Math.random() * 6.28
      });
    }

    function catchItem(it) {
      if (it.type === 'na') {
        score += 100;
        addFloater('+100', it.x, GLASS_Y, COL.na);
        burst(it.x, GLASS_Y, COL.na, 6);
        beep(620 + score / 20, 0.06);
        TIERS.forEach(function (t) {
          if (score >= t.mg && !tiersHit[t.key]) {
            tiersHit[t.key] = true;
            addFloater(t.label + ' UNLOCKED', W / 2, H / 2, COL.k, true);
            beep(780, 0.09); setTimeout(function () { beep(1040, 0.12); }, 100);
          }
        });
      } else if (it.type === 'heart') {
        lives = Math.min(3, lives + 1);
        addFloater('+1 LIFE', it.x, GLASS_Y, COL.k);
        burst(it.x, GLASS_Y, COL.k, 6);
        beep(880, 0.1);
      } else if (it.type === 'mg') {
        slowUntil = elapsed + 3;
        addFloater('SLOW-MO', it.x, GLASS_Y, COL.mg);
        burst(it.x, GLASS_Y, COL.mg, 6);
        beep(500, 0.14, 'sine');
      } else if (it.type === 'gold') {
        jackpot = true;
        addFloater('JACKPOT', W / 2, H / 2 - 30, COL.gold, true);
        burst(it.x, GLASS_Y, COL.gold, 16);
        beep(660, 0.08); setTimeout(function () { beep(880, 0.08); }, 90); setTimeout(function () { beep(1320, 0.18); }, 180);
      } else {
        lives -= 1;
        addFloater('SUGAR', it.x, GLASS_Y, COL.bad);
        burst(it.x, GLASS_Y, COL.bad, 9);
        if (!reducedMotion) {
          stage.classList.remove('is-shake');
          void stage.offsetWidth;
          stage.classList.add('is-shake');
        }
        beep(140, 0.18, 'sawtooth', 0.055);
        if (lives <= 0) { updateHud(); gameOver(); return; }
      }
      updateHud();
    }

    function drawGlass() {
      // Tall drinking glass: wide open top, gently tapered walls, heavy base.
      var x = Math.round(glassX), top = GLASS_Y, t = 4;
      var topHalf = GLASS_W / 2, botHalf = topHalf - 7;
      var bottom = top + GLASS_H;
      var baseT = 6;
      var innerTop = top + 5, innerBottom = bottom - baseT;
      function halfAt(y) {
        return topHalf + (botHalf - topHalf) * ((y - top) / GLASS_H);
      }

      var serving = (score % 800) / 800;
      if (score > 0 && serving === 0) serving = 1;
      if (serving > 0) {
        var fillTop = innerBottom - (innerBottom - innerTop) * serving;
        ctx.fillStyle = COL.liquid;
        ctx.beginPath();
        ctx.moveTo(x - (halfAt(fillTop) - t), fillTop);
        ctx.lineTo(x + (halfAt(fillTop) - t), fillTop);
        ctx.lineTo(x + (halfAt(innerBottom) - t), innerBottom);
        ctx.lineTo(x - (halfAt(innerBottom) - t), innerBottom);
        ctx.closePath();
        ctx.fill();
        ctx.fillStyle = '#7fd4ff';
        ctx.fillRect(x - (halfAt(fillTop) - t), fillTop, (halfAt(fillTop) - t) * 2, 3);
      }

      ctx.fillStyle = COL.glass;
      // tapered walls
      ctx.beginPath();
      ctx.moveTo(x - topHalf, top);
      ctx.lineTo(x - topHalf + t, top);
      ctx.lineTo(x - botHalf + t, bottom);
      ctx.lineTo(x - botHalf, bottom);
      ctx.closePath();
      ctx.fill();
      ctx.beginPath();
      ctx.moveTo(x + topHalf, top);
      ctx.lineTo(x + topHalf - t, top);
      ctx.lineTo(x + botHalf - t, bottom);
      ctx.lineTo(x + botHalf, bottom);
      ctx.closePath();
      ctx.fill();
      // heavy base slab
      ctx.fillRect(x - botHalf, bottom - baseT, botHalf * 2, baseT);
      // rim highlight
      ctx.fillStyle = 'rgba(234,242,255,0.4)';
      ctx.fillRect(x - topHalf, top, topHalf * 2, 2);

      if (timeScale < 0.95) {
        ctx.globalAlpha = (1 - timeScale) / 0.55;
        ctx.strokeStyle = COL.mg;
        ctx.lineWidth = 2;
        ctx.strokeRect(x - topHalf - 5, top - 5, topHalf * 2 + 10, GLASS_H + 10);
        ctx.globalAlpha = 1;
      }
    }

    function draw() {
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = COL.star;
      stars.forEach(function (st) {
        var a = 0.5 + Math.sin(st.tw + elapsed * 1.4) * 0.5;
        ctx.globalAlpha = a * 0.5;
        ctx.fillRect(st.x, st.y, 2, 2);
      });
      ctx.globalAlpha = 1;
      ctx.fillStyle = 'rgba(234,242,255,0.14)';
      ctx.fillRect(0, H - 14, W, 3);

      items.forEach(function (it) {
        var sp = SPR[it.type];
        var sz = ITEM_SIZE[it.type];
        var wobX = it.type === 'gold' ? 0 : Math.sin(it.wob + elapsed * 3) * 4;
        ctx.drawImage(sp, Math.round(it.x + wobX - sz / 2), Math.round(it.y - sz / 2), sz, Math.round(sz * sp.height / sp.width));
      });

      particles.forEach(function (p) {
        ctx.globalAlpha = Math.max(0, p.life * 1.7);
        ctx.fillStyle = p.color;
        ctx.fillRect(Math.round(p.x) - 2, Math.round(p.y) - 2, 4, 4);
        ctx.globalAlpha = 1;
      });

      drawGlass();

      floaters.forEach(function (f) {
        ctx.globalAlpha = Math.max(0, Math.min(1, f.life * 1.6));
        ctx.fillStyle = f.color;
        ctx.font = (f.big ? 13 : 9) + 'px "Press Start 2P", monospace';
        ctx.textAlign = 'center';
        ctx.fillText(f.text, f.x, f.y - 26);
        ctx.globalAlpha = 1;
      });

      if (timeScale < 0.95) {
        ctx.globalAlpha = (1 - timeScale) / 0.55;
        ctx.fillStyle = 'rgba(179,136,255,0.09)';
        ctx.fillRect(0, 0, W, H);
        ctx.globalAlpha = 1;
      }
    }

    function frame(ts) {
      if (!running) return;
      var dt = Math.min(0.05, (ts - lastTs) / 1000 || 0);
      lastTs = ts;
      // Slow-mo eases in and out (~0.3s) instead of snapping, so it reads as
      // a power-up kicking in rather than a glitch.
      var target = elapsed < slowUntil ? 0.45 : 1;
      timeScale += (target - timeScale) * Math.min(1, dt * 6);
      var mult = timeScale;
      elapsed += dt;
      updateClock();
      // Hard shot clock: the round ends when time is up, keeping whatever
      // reward was earned. Slow-mo does not stretch the wall clock.
      if (elapsed >= DURATION) { gameOver(); return; }

      spawnAt -= dt * mult;
      if (spawnAt <= 0) {
        spawn();
        spawnAt = Math.max(0.3, 0.85 - elapsed * 0.009 - score * 0.00012);
      }
      maybeSpawnGold();

      for (var i = items.length - 1; i >= 0; i--) {
        var it = items[i];
        it.y += it.vy * dt * mult;
        if (it.zig) it.x += Math.cos(it.wob + elapsed * 4) * it.zig * dt * mult;
        else it.x += it.drift * dt * mult;
        if (it.x < 16) it.x = 16;
        if (it.x > W - 16) it.x = W - 16;
        var caught = it.y > GLASS_Y - 4 && it.y < GLASS_Y + 24 && Math.abs(it.x - glassX) < GLASS_W / 2 + 8;
        if (caught) {
          items.splice(i, 1);
          catchItem(it);
          if (!running) return;
        } else if (it.y > H + 30) {
          items.splice(i, 1);
        }
      }
      for (i = floaters.length - 1; i >= 0; i--) {
        floaters[i].y -= 40 * dt;
        floaters[i].life -= dt;
        if (floaters[i].life <= 0) floaters.splice(i, 1);
      }
      for (i = particles.length - 1; i >= 0; i--) {
        var p = particles[i];
        p.x += p.vx * dt; p.y += p.vy * dt; p.vy += 540 * dt; p.life -= dt;
        if (p.life <= 0) particles.splice(i, 1);
      }

      draw();
      rafId = requestAnimationFrame(frame);
    }

    function start() {
      reset();
      running = true;
      show(null);
      lastTs = performance.now();
      rafId = requestAnimationFrame(frame);
      beep(440, 0.07); setTimeout(function () { beep(660, 0.07); }, 90);
    }

    function bestTier() {
      var t = null;
      TIERS.forEach(function (tt) { if (score >= tt.mg) t = tt; });
      return t;
    }

    function gameOver() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
      if (score > hi) {
        hi = score;
        hiEl.textContent = hi;
        try { localStorage.setItem('sra-hi', String(hi)); } catch (e) {}
      }
      var tier = bestTier();
      var runRank = jackpot ? 4 : tier ? { '10': 1, '15': 2, '20': 3 }[tier.key] : 0;
      if (runRank > bestRank) { bestRank = runRank; writeRank('sra-best-rank', bestRank); }
      root.querySelector('[data-sra-final]').textContent = score;
      var rewardBlock = root.querySelector('[data-sra-reward-block]');
      var noReward = root.querySelector('[data-sra-noreward]');
      var rewardEl = root.querySelector('[data-sra-reward]');
      var replayCta = root.querySelector('[data-sra-replay-cta]');
      var titleEl = root.querySelector('[data-sra-over-title]');
      rewardBlock.hidden = true; noReward.hidden = true;
      if (bestRank > 0) {
        // The email form shows after EVERY rewarded run (owner's call: codes
        // are once-per-customer at checkout, so re-sending is harmless).
        // The offer is always the banked best, never a downgrade.
        rewardBlock.hidden = false;
        rewardEl.textContent = (bestRank > runRank ? 'BEST SO FAR: ' : '') + RANK_LABEL[bestRank];
        rewardEl.classList.toggle('is-gold', bestRank === 4);
        root.querySelector('[data-sra-bank-note]').hidden = bestRank === 4;
        titleEl.textContent = runRank === 4 ? 'JACKPOT' : runRank > 0 ? 'YOU WIN' : (elapsed >= DURATION ? 'TIME UP' : 'GAME OVER');
        replayCta.textContent = bestRank < 4 ? 'RUN IT BACK FOR A BIGGER ONE' : 'TAP HERE TO PLAY AGAIN';
      } else {
        noReward.hidden = false;
        titleEl.textContent = elapsed >= DURATION ? 'TIME UP' : 'GAME OVER';
        replayCta.textContent = 'TAP HERE TO PLAY AGAIN';
      }
      updateClock();
      var sendBtn = root.querySelector('[data-sra-send]');
      sendBtn.disabled = false;
      sendBtn.textContent = 'GET CODE';
      beep(300, 0.12, 'sawtooth', 0.045); setTimeout(function () { beep(200, 0.2, 'sawtooth', 0.045); }, 140);
      show('over');
    }

    // --- email gate ----------------------------------------------------
    root.querySelector('[data-sra-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = root.querySelector('[data-sra-email]');
      var err = root.querySelector('[data-sra-mail-err]');
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        err.hidden = false;
        return;
      }
      err.hidden = true;
      var sendBtn = root.querySelector('[data-sra-send]');
      sendBtn.disabled = true;
      sendBtn.textContent = 'SENDING...';
      // The event always carries the BANKED best reward, not just this run's.
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['identify', { $email: email }]);
      window.klaviyo.push(['track', 'Salt Rush Win', {
        tier: RANK_KEY[bestRank] || 'none',
        reward: RANK_LABEL[bestRank] || '',
        score_mg: Math.max(score, hi),
        jackpot: bestRank === 4,
        upgraded: sentRank > 0 && bestRank > sentRank
      }]);
      sentRank = bestRank;
      writeRank('sra-sent-rank', sentRank);
      try { localStorage.setItem('sra-email', email); } catch (e2) {}
      root.querySelector('[data-sra-sent-to]').textContent = email.toUpperCase();
      beep(700, 0.08); setTimeout(function () { beep(1050, 0.12); }, 100);
      setTimeout(function () { show('sent'); }, 500);
    });

    // --- input ---------------------------------------------------------
    function pointerX(e) {
      var r = canvas.getBoundingClientRect();
      return ((e.clientX - r.left) / r.width) * W;
    }
    function moveTo(x) {
      glassX = Math.min(W - GLASS_W / 2, Math.max(GLASS_W / 2, x));
    }
    stage.addEventListener('pointerdown', function (e) {
      if (!running) return;
      moveTo(pointerX(e));
    });
    stage.addEventListener('pointermove', function (e) {
      if (!running) return;
      moveTo(pointerX(e));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        window.location.href = root.dataset.exit || '/';
        return;
      }
      if (!running) return;
      if (e.key === 'ArrowLeft') { moveTo(glassX - 30); e.preventDefault(); }
      if (e.key === 'ArrowRight') { moveTo(glassX + 30); e.preventDefault(); }
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && running) lastTs = performance.now();
    });

    root.querySelector('[data-sra-start]').addEventListener('click', start);
    root.querySelectorAll('[data-sra-replay]').forEach(function (b) { b.addEventListener('click', start); });

    // Prefill the email so GET CODE is one tap: logged-in customer first,
    // otherwise whatever they entered last time on this device.
    var knownEmail = root.dataset.customerEmail || '';
    if (!knownEmail) {
      try { knownEmail = localStorage.getItem('sra-email') || ''; } catch (e) {}
    }
    if (knownEmail) root.querySelector('[data-sra-email]').value = knownEmail;
  });

  } catch(e) { console.error(e); }
})();
})();
